<template>
  <div class="setting-base-map">
    <TitleBar :text="$t('SettingBaseMap.topic')" :showIconButton="false" @clickCloseButton="clickCloseButton" />
    <div class="body">
      <button class="base-map" v-for="baseMap in baseMapList" :key="baseMap.value" @click="selectBaseMap(baseMap)">
        <img :src="util.getImagePath(`${baseMap.imageName}@2x.png`)" :srcset="util.getImageSet(baseMap.imageName)">
        <label>{{ baseMap.displayName[$i18n.locale] }}</label>
      </button>
    </div>
  </div>
</template>

<script>
import TitleBar from '@/components/TitleBar.vue'

export default {
  name: 'SettingBaseMap',
  components: {
    TitleBar
  },
  props: {
    map: {
      type: Object,
      defualt: null
    }
  },
  data () {
    return {
      baseMapList: [
        {
          imageName: 'base_map_poi',
          valueTh: 'POI',
          valueEn: 'POI_EN',
          displayName: {
            th: 'สถานที่',
            en: 'Place'
          },
          zoomRange: {
            max: 20,
            min: 1
          }
        },
        {
          imageName: 'base_map_traffic',
          valueTh: 'POI',
          valueEn: 'POI_EN',
          displayName: {
            th: 'จราจร',
            en: 'Traffic'
          },
          zoomRange: {
            max: 20,
            min: 1
          }
        },
        {
          imageName: 'base_map_satellite',
          valueTh: 'ARCGIS_WORLD_IMAGERY',
          valueEn: 'ARCGIS_WORLD_IMAGERY',
          displayName: {
            th: 'ดาวเทียม',
            en: 'Satellite'
          },
          zoomRange: {
            max: 19,
            min: 1
          }
        }
      ]
    }
  },
  methods: {
    clickCloseButton () {
      var self = this
      self.$router.back()
    },
    selectBaseMap (baseMap) {
      var self = this
      self.map.Layers.setBase(window.longdo.Layers[self.$i18n.locale === 'th' ? baseMap.valueTh : baseMap.valueEn])
      if (baseMap.imageName === 'base_map_traffic') {
        self.map.Layers.add(window.longdo.Layers.TRAFFIC)
      } else {
        self.map.Layers.remove(window.longdo.Layers.TRAFFIC)
      }
      var currentZoom = self.map.zoom()
      if (currentZoom < baseMap.zoomRange.min) {
        self.map.zoom(baseMap.zoomRange.min)
      }
      if (currentZoom > baseMap.zoomRange.max) {
        self.map.zoom(baseMap.zoomRange.max)
      }
      self.clickCloseButton()
    }
  }
}
</script>

<style scoped>
  .setting-base-map {
    width: 300px;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    position: relative;
    overflow: hidden;
    margin-top: auto;
    margin-bottom: auto;
  }

  .body {
    box-sizing: border-box;
    background: rgb(255, 255, 255);
    position: relative;
    overflow: hidden;
    overflow-y: auto;
    padding: 16px 16px 0px 16px;
  }

  .base-map {
    width: 126px;
    height: 126px;
    padding: 0px;
    border: none;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.2);
    position: relative;
  }

  .base-map:nth-child(2n-1) {
    margin-right: 16px;
    margin-bottom: 16px;
  }

  .base-map img {
    width: 126px;
    height: 126px;
  }

  .base-map label {
    position: absolute;
    right: 0px;
    bottom: 0px;
    font-size: 18px;
    font-family: Prompt;
    padding: 0px 8px;
    font-weight: bold;
    text-shadow: 
      -1px -1px 0 rgb(255, 255, 255),  
      1px -1px 0 rgb(255, 255, 255),
      -1px 1px 0 rgb(255, 255, 255),
      1px 1px 0 rgb(255, 255, 255);
  }

  .body::-webkit-scrollbar-button {
    height: 12.5px;
  }
  .body::-webkit-scrollbar {
    background-color: rgb(251, 251, 251);
  }
  .body::-webkit-scrollbar-thumb {
    border: 2px solid rgb(251, 251, 251);
  }

  /* @media only screen and (max-width: 768px) {
    .setting-base-map {
      width: 100%;
      min-width: 320px;
      height: 100%;
      border-radius: 0px;
    }

    .body {
      height: calc(100% - 50px);
    }
  } */
</style>



// WEBPACK FOOTER //
// src/components/SettingBaseMap.vue